﻿import "./modal.scss";
import 'bootstrap/js/dist/modal';

(function ($) {
    //Declare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Modal = {};

    // set default configurations
    var configurations = {
        name: "Fundraising Modal",
        version: 1.0,
        delay: 0,
        openModalDelay: 500,
        iframeResizeDelay: 100,
        resizeIframeHeightBuffer: 5,
        allowMultipleClass: 'allow-multiple'
    };

    function handleModalFormErrors() {
        $(document).on('click', '#popup-div input[type=submit]', function () {
            const $formFrm = $(this).closest('form');
            if ($formFrm.find('.input-validation-error')) M2.Modal.resizeParentIframe();
        });
    }
        
    function handleModaliFrameResize() {
        var hasIframe = document.querySelector('.iframe-wrapper') ? true : false;
        if (hasIframe) {
            var iframe = document.querySelector('.iframe-wrapper').querySelectorAll('iframe')[0];
            M2.Modal.resizeIframe(iframe);
        }
    }

    function setOverlayTrigger() {

        $(document).on('change', '.switch-modal', function (e) {
            var showState = $(this).data('modal-show-checked');
            var switchState = $(this).prop('checked');
            var isInline = ($(this).hasClass('inline-modal')) ? true : false;
            var modalTitle = $(this).data('modal-title');
            var modalId = $(this).data('modal-id');
            var modalSize = $(this).data('modal-size');
            var contentTarget = $(this).data('modal-content');
            if (showState === switchState) M2.Modal.create(modalId, modalTitle, contentTarget, modalSize, isInline);
        });

        $(document).on("click", ".wtd-overlay, .m2-modal", function (e) {
            //Stop default action and scroll to top
            e.preventDefault();
            var $this = $(this);

            // If we are validating a form before the overlay, check
            if ($(this).hasClass("valid-form") && !$(this).closest("form").valid()) {
                return false;
            }

            var modalId = $this.data("modal-id") !== undefined ? $this.data("modal-id") : $this.attr("data-target");

            $(".popup-container .video-preview").show();

            var modalTitle = $this.data('modal-title');
            var modalSize = $this.data('modal-size') ? $this.data('modal-size') : '';
            var modalDelay = $this.data('modal-delay') ? $this.data('modal-delay') : null;

            var modalBackground = $this.data('modal-background') ? $this.data('modal-background') : 'true';

            var allowMultipleModal = $this.hasClass(M2.Modal.config.allowMultipleClass);

            if ($this.hasClass("iframe")) {
                var iframeUrl = $this.data("modal-url") !== undefined ? $this.data("modal-url") : $this.attr('href');
                M2.Modal.create(modalId, modalTitle, iframeUrl, modalSize, null, modalBackground, modalDelay, allowMultipleModal);
            } else {
                var contentTarget = $this.data('modal-content');
                if ($this.hasClass('use-parent')) window.parent.M2.Modal.create(modalId, modalTitle, contentTarget, modalSize, true, modalBackground, modalDelay, allowMultipleModal);
                M2.Modal.create(modalId, modalTitle, contentTarget, modalSize, true, modalBackground, modalDelay, allowMultipleModal);
            }
            return false;
        });
        /* ######## Start Overlay ###ea####### */

        window.M2.Modal.Close = function () {
            $('.modal.show').modal('hide');
        };

        $(document).on("click", ".close-iframe-modal", function (e) {
            e.preventDefault();
            window.parent.M2.Modal.Close();
            if (typeof M2.Util !== "undefined" && typeof M2.Util.stopMediaPlayer !== "undefined") M2.Util.stopMediaPlayer();
        });
        // Special close only for form submissions within overlay
        $(document).on("click", ".yes.btn", function (e) {
            $('.modal').modal('hide');
        });
        /* ######## End Overlay ########## */
    }

    M2.Modal = {
        config: configurations,
        init: function () {
            setOverlayTrigger();
            this.setModalTableRow();
            handleModalFormErrors();
        },
        create: function (modalId, modalTitle, contentSrc, size, isInline, backdrop, delay, allowMultiple, callback) {
            if (typeof modalId === "undefined") modalId = 'modal-overlay';
            if (typeof modalTitle === "undefined") modalTitle = null;
            if (typeof contentSrc === "undefined") contentSrc = null;
            if (typeof size === "undefined" || size === null) size = "";
            if (typeof backdrop === "undefined") backdrop = true;
            if (typeof delay === "undefined" || delay === null) delay = M2.Modal.config.delay;
            if (typeof allowMultiple === "undefined") allowMultiple = false;

            if (modalId.includes('#')) modalId = modalId.substr(1);
            var hasInlineVideo;

            // Open new modal
            var jQueryTargetRef = "#" + modalId;

            // Check for open modals and close if open
            var modalIsOpen = $('body').hasClass('modal-open') ? true : false;
            if (modalIsOpen && !allowMultiple) {
                M2.Modal.close();
                delay = M2.Modal.config.openModalDelay;
            }

            window.setTimeout(function () {

                // Modal Container
                var $modalContainer = $('<div/>', {
                    id: modalId,
                    'class': 'modal fade dynamic',
                    'role': 'dialog',
                    'arial-hidden': true
                });

                // If one sheet overlay, set print css
                if ($modalContainer.hasClass("one-sheet") || $modalContainer.hasClass("print-avatar")) {
                    $("body").addClass("print-overlay");
                }

                // Modal Dialog
                var $modalDialog = $('<div/>', {
                    'class': 'modal-dialog modal-dialog-centered ' + size,
                    'role': 'document'
                });

                $modalContainer.append($modalDialog);

                // Modal Content
                var $modalContent = $('<div/>', {
                    'class': 'modal-content'
                });

                $modalDialog.append($modalContent);

                // Modal Header
                var $modalHeader = $('<div/>', {
                    'class': 'modal-header'
                });

                $modalContent.append($modalHeader);

                if (modalTitle) {
                    // Modal Header Title
                    var $modalTitle = $('<h5/>', {
                        'class': 'modal-title',
                        id: modalId + '_title'
                    }).html(modalTitle);
                    $modalHeader.append($modalTitle);
                }

                // Modal Close Button
                var $closeButton = $('<button/>', {
                    'class': 'close',
                    'data-dismiss': 'modal',
                    'arial-label': 'Close'
                });

                $modalHeader.append($closeButton);

                // Modal Close Icon
                var $closeIcon = $('<span />', {
                    'aria-hidden': true
                }).html('&times');

                $closeButton.append($closeIcon);

                // Modal Content Body

                var $modalBody = $('<div/>', {
                    id: modalId + '-body',
                    'class': 'modal-body'
                });

                $modalContent.append($modalBody);

                if (isInline) {
                    $modalBody.addClass('inline-content');
                    var $contentSrc = $(contentSrc);
                    var $content = $(contentSrc).clone(true);
                    hasInlineVideo = $content.find('.inline-modal-video').length > 0 ? true : false;
                    // Disable/enable form inputs to prevent duplicate input issues
                    $contentSrc.find('input').prop("disabled", true);
                    $content.find('input').prop("disabled", false);
                    $content.removeClass('hidden');

                    var $modalContent = $('<div/>', {
                        'class': 'modal-container'
                    });

                    var $popContainer = $('<div/>', {
                        'class': 'popup-container'
                    });

                    var $innerContent = $('<div/>', {
                        'class': 'inner-content'
                    });
                    $modalContent.appendTo($modalBody);
                    $popContainer.appendTo($modalContent);
                    $innerContent.appendTo($popContainer);
                    $content.appendTo($innerContent);
                } else {
                    $modalBody.addClass('iframe-content');

                    var $iFrameWrapper = $('<div/>', {
                        'class': 'iframe-wrapper'
                    });

                    // Modal iFrame Content
                    var modaliFrame = document.createElement("iframe");
                    modaliFrame.id = "iframe-" + modalId;
                    modaliFrame.src = contentSrc;
                    modaliFrame.frameborder = 0;
                    modaliFrame.width = '100%';
                    modaliFrame.setAttribute('allowFullScreen', 'true');
                    modaliFrame.setAttribute('webkitallowfullscreen', 'true');
                    modaliFrame.setAttribute('mozallowfullscreen', 'true');
                    modaliFrame.setAttribute('allowtransparency', 'true');

                    modaliFrame.onload = function () {
                        var iframeRef = this;
                        M2.Modal.resizeIframe(iframeRef, M2.Modal.config.iframeResizeDelay);
                    };

                    $iFrameWrapper.append($(modaliFrame));
                    $modalBody.append($iFrameWrapper);
                    window.addEventListener('resize', handleModaliFrameResize);
                }

                // Attach everything together and to the DOM
                $('body').prepend($modalContainer);

                $(jQueryTargetRef).modal({
                    backdrop: backdrop,
                    keyboard: false
                });

                // If we are opening multiple modals, make sure the latest is on top

                if (allowMultiple) {
                    var $backdrop = $('.modal-backdrop').last();
                    var currentModalZ = parseInt($(jQueryTargetRef).css('z-index'));
                    var currentBackdropZ = parseInt($backdrop.css('z-index'));
                    $(jQueryTargetRef).css('z-index', currentModalZ + 10);
                    $backdrop.css('z-index', currentBackdropZ + 10);
                }

                // Remove this Modal should it ever be closed
                $(jQueryTargetRef).on('hidden.bs.modal', function (e) {
                    if (modaliFrame) window.removeEventListener('resize', handleModaliFrameResize);
                    $(jQueryTargetRef).remove();
                });

                // Close the drop down if it's open
                $('.user-menu').removeClass('show-menu');

                if (callback) {
                    callback();
                }

            }, delay);
        },
        createError: function (modalId, modalTitle, content, backdrop, delay, callback) {
            if (typeof modalId === "undefined") modalId = 'modal-error-overlay';
            if (typeof modalTitle === "undefined") modalTitle = null;
            if (typeof contentSrc === "undefined") content = null;
            if (typeof backdrop === "undefined") backdrop = true;
            if (typeof delay === "undefined" || delay === null) delay = M2.Modal.config.delay;

            const jQueryTargetRef = "#" + modalId;

            // Check for open modals and close if open
            const modalIsOpen = $('body').hasClass('modal-open');
            if (modalIsOpen) {
                M2.Modal.close();
                delay = M2.Modal.config.openModalDelay;
            }

            window.setTimeout(function () {

                // Modal Container
                var $modalContainer = $('<div/>', {
                    id: modalId,
                    'class': 'modal fade dynamic',
                    'role': 'dialog',
                    'arial-hidden': true
                });

                // Modal Dialog
                var $modalDialog = $('<div/>', {
                    'class': 'modal-dialog error-message modal-dialog-centered modal-xs',
                    'role': 'document'
                });

                $modalContainer.append($modalDialog);

                // Modal Content
                var $modalContent = $('<div/>', {
                    'class': 'modal-content'
                });

                $modalDialog.append($modalContent);

                // Modal Header
                var $modalHeader = $('<div/>', {
                    'class': 'modal-header'
                });

                $modalContent.append($modalHeader);

                if (modalTitle) {
                    // Modal Header Title
                    var $modalTitle = $('<h5/>', {
                        'class': 'modal-title',
                        id: modalId + '_title'
                    }).html(modalTitle);
                    $modalHeader.append($modalTitle);
                }

                // Modal Close Button
                var $closeButton = $('<button/>', {
                    'class': 'close',
                    'data-dismiss': 'modal',
                    'arial-label': 'Close'
                });

                $modalHeader.append($closeButton);

                // Modal Close Icon
                var $closeIcon = $('<span />', {
                    'aria-hidden': true
                }).html('&times');

                $closeButton.append($closeIcon);

                // Modal Content Body

                var $modalBody = $('<div/>', {
                    id: modalId + '-body',
                    'class': 'modal-body'
                });

                $modalContent.append($modalBody);

                $modalBody.addClass('inline-content');
                var $content = $("<div />", {
                    text: content, 
                })

                $modalContent = $('<div/>', {
                    'class': 'modal-container'
                });

                var $popContainer = $('<div/>', {
                    'class': 'popup-container'
                });

                var $innerContent = $('<div/>', {
                    'class': 'inner-content'
                });
                $modalContent.appendTo($modalBody);
                $popContainer.appendTo($modalContent);
                $innerContent.appendTo($popContainer);
                $content.appendTo($innerContent);

                // Attach everything together and to the DOM
                $('body').prepend($modalContainer);

                $(jQueryTargetRef).modal({
                    backdrop: backdrop,
                    keyboard: false
                });

                // Remove this Modal should it ever be closed
                $(jQueryTargetRef).on('hidden.bs.modal', function (e) {
                    $(jQueryTargetRef).remove();
                });

                // Close the drop down if it's open
                $('.user-menu').removeClass('show-menu');

                if (callback) {
                    callback();
                }
            }, delay);
        },
        setModalTableRow: function () {
            $(document).on("click", "table.modal-row tr td", function (e) {
                var allowClick = M2.Util.isRowClickAllowed(e.target);
                if (allowClick) {
                    e.preventDefault();
                    const $row = $(this).closest('tr');
                    var iframeURL = $row.data("modal-url");
                    var modalIndentifier = $row.data("modal-id");
                    var modalTitle = $row.data("modal-title");
                    var modalSize = $row.data("modal-size");
                    M2.Modal.create(modalIndentifier, modalTitle, iframeURL, modalSize);
                }
            });
        },
        resizeModal: function (iframeId) {
            $('.modal').modal('handleUpdate');
        },
        resizeIframe: function (iframe, resizeDelay) {
            if (typeof resizeDelay === "undefined") resizeDelay = 0;
            window.setTimeout(function () {
                try {
                    iframe.height = (iframe.contentWindow.document.body.scrollHeight + M2.Modal.config.resizeIframeHeightBuffer) + "px";
                } catch (e) {
                    console.log(e);
                }
            }, resizeDelay);
        },
        resizeParentIframe: function (resizeDelay) {
            if (typeof resizeDelay === "undefined") resizeDelay = 0;
            window.setTimeout(function () {
                try {
                    var iframe = parent.document.getElementById(window.frameElement.id);
                    parent.M2.Modal.resizeIframe(iframe);
                } catch (e) {
                    console.log(e);
                }
            }, resizeDelay);
        },
        close: function () {
            $('.modal').modal('hide');
        },
        handleFormOnFailure: function () {

        }
    };
})(jQuery);

$(function () {
    M2.Modal.init();
});